import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$getRoot} from 'lexical';
import {FC, useEffect, useRef} from 'react';
import {$generateNodesFromDOM} from '@lexical/html';
import {useEmailContext} from '../../../../../context';
import {generatingHtmlString} from '../../ToolbarPlugin/utils';

export interface IInsertHtmlAndImagesPlugin {
    htmlString: string;
    isFromTextEditor?: boolean;
}

export const InsertHtmlAndImagesPlugin: FC<IInsertHtmlAndImagesPlugin> = ({
    htmlString,
    isFromTextEditor
}) => {
    const [editor] = useLexicalComposerContext();
    const isMounted = useRef(false);

    const {
        states: {language}
    } = useEmailContext();

    useEffect(() => {
        editor.update(() => {
            if (!htmlString || isMounted.current) return;
            isMounted.current = true;

            const encodedHtmlString = generatingHtmlString(htmlString, isFromTextEditor);

            const parser = new DOMParser();
            const dom = parser.parseFromString(encodedHtmlString, 'text/html');
            const nodes = $generateNodesFromDOM(editor, dom);
            const root = $getRoot();
            root.clear();
            root.append(...nodes);
        });
    }, [editor, htmlString, language]);

    return null;
};
